export default __webpack_public_path__ + "static/media/hht2_ep03_timeline_01.00996315.png";